import { Message } from "primereact/message";
import { Tooltip } from "primereact/tooltip";

import { Dropdown, FormField, Icon, RadioGroup, SelectableCard } from "@/ds";
import modal from "../planejamento-controle.modal.module.scss";
import styles from "./dominancia-bloco.module.scss";
import type { DominanciaBlocoViewModel } from "./types-dominancia-bloco";

const ROTULO = { label: modal.rotuloCampo };
const PAINEL = { panel: { className: modal.painel } };

export function DominanciaBlocoView({
  titulo,
  aviso,
  cartoes,
  seletor,
  disabled,
  testId,
  infoId,
  infoSelector,
  tooltipProps,
}: DominanciaBlocoViewModel) {
  return (
    <section className={styles.bloco} data-testid={testId}>
      {titulo ? (
        <div className={styles.titulo}>
          <span>{titulo.texto}</span>
          <span id={infoId} className={styles.info} tabIndex={0}>
            <Icon name="info-circle" size={14} />
          </span>
          {tooltipProps ? <Tooltip target={infoSelector} {...tooltipProps} /> : null}
        </div>
      ) : null}

      {aviso ? (
        <Message
          className="p-message-block"
          severity="warn"
          text={aviso.texto}
          data-testid={aviso.testId}
        />
      ) : null}

      {cartoes ? (
        <RadioGroup.Root
          value={cartoes.value}
          onChange={cartoes.onChange}
          disabled={disabled}
          aria-label={cartoes.label}
          testId={cartoes.testId}
        >
          <div className={styles.cartoes}>
            {cartoes.itens.map((cartao) => (
              <SelectableCard
                key={cartao.value}
                value={cartao.value}
                aria-label={cartao.titulo}
                data-testid={cartao.testId}
              >
                <span className={styles.cartaoCorpo}>
                  <span className={styles.cartaoTitulo}>
                    {cartao.titulo}{" "}
                    {cartao.destaque ? (
                      <span data-testid={cartao.destaqueTestId}>{cartao.destaque}</span>
                    ) : null}
                  </span>
                  <span className={styles.cartaoDescricao}>{cartao.descricao}</span>
                </span>
              </SelectableCard>
            ))}
          </div>
        </RadioGroup.Root>
      ) : null}

      {seletor ? (
        <FormField.Root
          required
          classNames={ROTULO}
          help={seletor.ajuda ?? undefined}
          error={seletor.error}
          disabled={disabled || seletor.travado}
        >
          <FormField.Label>{seletor.label}</FormField.Label>
          <FormField.Control>
            <Dropdown
              appendTo="self"
              pt={PAINEL}
              value={seletor.value}
              options={seletor.opcoes}
              placeholder={seletor.placeholder}
              onChange={(event) => seletor.onChange(event.value)}
              data-testid={seletor.testId}
            />
          </FormField.Control>
          <FormField.Help />
          <FormField.Error data-testid={seletor.errorTestId} />
        </FormField.Root>
      ) : null}
    </section>
  );
}
